
export const initCardGlow = () => {
  document.querySelectorAll<HTMLDivElement>('.card-glow').forEach(card => {
    if (card.hasAttribute("data-inizialized")) {
      return
    }
    
    card.addEventListener('mousemove', e => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--mouse-x', (e.clientX - rect.left) + 'px')
      card.style.setProperty('--mouse-y', (e.clientY - rect.top) + 'px')
    })
    card.addEventListener('mouseenter', () => {
      card.style.setProperty('--glow-opacity', '1');
    })
    card.addEventListener('mouseleave', () => {
      card.style.setProperty('--glow-opacity', '0');
    })

    card.setAttribute("data-inizialized", "true")
  })
}